<!-- 销售订单 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <wdtOrdeAction v-if="showStatus" ref="wdtOrdeAction" @drawerCancel="drawerCancel" :actionData="actionData">
            </wdtOrdeAction>
        </el-drawer>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="成功单据" name="first">
                <div class="page_content_top">
                    <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search v-if="pageShowData.jurHead" :flagList="['orderState']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData"
                                  @openSearch="openSearch">
                            <template slot="searchInput" slot-scope="{formOneValue}">
                                <el-select filterable v-if="formOneValue.entityField == 'orderState'" v-model="getRequestData[formOneValue.entityField]">
                                    <el-option v-for="(values, keys) in JSON.parse(formOneValue.formatterContent)" :key="keys" :label="values.value" :value="values.key">
                                    </el-option>
                                </el-select>
                            </template>
                        </v-search>
                    </div>
                </div>
                <div class="page_content_center">
                    <el-table v-if="pageShowData.jurTableVo" @sort-change="sortChange" class="table1" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                              highlight-current-row size="mini" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip
                                         :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField" :sortable="tableValye.isSort == 1 ? 'custom' : false">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                                    }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="原始单据" name="second">
                <div class="page_content_top">
                    <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search v-if="pageShowData.jurHead" :flagList="['orderState']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData"
                                  @openSearch="openSearch">
                            <template slot="searchInput" slot-scope="{formOneValue}">
                                <el-select filterable v-if="formOneValue.entityField == 'orderState'" v-model="getRequestData[formOneValue.entityField]">
                                    <el-option v-for="(values, keys) in JSON.parse(formOneValue.formatterContent)" :key="keys" :label="values.value" :value="values.key">
                                    </el-option>
                                </el-select>
                            </template>
                        </v-search>
                    </div>
                </div>
                <div class="page_content_center">
                    <el-table ref="ysData" v-if="pageShowData.jurTableVo" @sort-change="sortChange" class="table1" :data="returnData.list" :height="(tableHeight / 2) - 40" :key="$store.state.tableNum" border
                              style="width: 100%" size="mini" @row-click="rowClick" :row-class-name="rowClassName">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip
                                         :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField" :sortable="tableValye.isSort == 1 ? 'custom' : false">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                                    }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
                <el-table v-if="pageShowData.jurFormVoList.length > 0" @sort-change="sortChange" class="table1" :data="returnData.detailsList" :height="(tableHeight / 2) - 30" :key="$store.state.tableNum" border
                          style="width: 100%" highlight-current-row size="mini">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurFormVoList[0].jurconfigform" :key="tableKey" show-overflow-tooltip
                                     :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField" :sortable="tableValye.isSort == 1 ? 'custom' : false">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                    scope.row[tableValye.entityField] }}</a>
                            </span>
                            <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                                }}</el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import wdtOrdeAction from "@/components/wdtOrdeAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme, wdtOrdeAction },
    data() {
        //这里存放数据
        return {
            activeName: 'first',
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                total: 0,  // 总条数
                list: [],
                detailsList: [],
            },
            selectedDataIndex: 0,
            sField: '',
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            tabForm: [],
            seTitle: "",//检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            cmId: 0,
            parentSearchData: {},
            multipleSelection: [],
            //------
            actionData: {},
            showStatus: false,

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        rowClick(row) {
            this.selectedDataIndex = row.index
            this.getDetailsList()
        },
        rowClassName({ row }) {
            console.log(row, this.selectedDataIndex);
            console.log(row.index === this.selectedDataIndex, "测试");

            let rowName = ""
            if (row.index == this.selectedDataIndex) {
                rowName = "rowStyle"
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        drawerCancel(val) {
            this.showStatus = false
            if (val) {
                this.getDataList()
            }
        },
        handleClick() {
            this.getRequestData = {}
            this.getPageInfo()
        },
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: { isPenetrate } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        // 检索Id, 索引(表格中), 标识
        openSearch1(sId, index, type, sField) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.cmId = dataInfo.cmId
                        this.getRequestData.cmName = dataInfo.cmName
                    }

                    break;

                default:
                    this.getRequestData[name] = value

            }
        },

        async getPageInfo() {
            var pathId = ""
            if (this.activeName == 'first') {
                pathId = parent.getMenuInfo(this.$route.path)
            } else if (this.activeName == "second") {
                pathId = {
                    jurId: 16093988833561
                }
            }
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getJur() {
            let responseData = await this.$http.getJur({ ids: [1609378973848] })
            if (responseData.status == 200) {
                this.tabForm = responseData.result.jurFormVoList
                // 合并 stId 相同的商品，叠加 orderNum 数量
                var mergedData = {}
                this.multipleSelection.forEach(item => {
                    if (mergedData[item.bgsId]) {
                        // 如果已存在相同 stId 的商品，叠加数量
                        mergedData[item.bgsId].orderNum += item.orderNum//订单数量
                        //
                        mergedData[item.bgsId].saleableNum += item.saleableNum//可销数量
                        mergedData[item.bgsId].pieceNum += item.pieceNum//件数
                        mergedData[item.bgsId].wholeNum += item.wholeNum//整件数量
                        mergedData[item.bgsId].scatNum += item.scatNum//零散数量
                        this.calculatePrice(mergedData[item.bgsId])
                    } else {
                        // 如果不存在，添加新商品
                        mergedData[item.bgsId] = JSON.parse(JSON.stringify(item))
                    }
                })
                // 将合并后的数据转换为数组
                var finalData = Object.values(mergedData)
                console.log(finalData, "测试");
                this.actionData = {
                    cate: 0, formData: this.tabForm,
                    oldData: finalData, orderId: '', printSouce: '',
                    printJurId: '', type: 'one'
                }
                this.showStatus = true
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        calculatePrice(item) {
            const info = item
            const taxRate = parseFloat(info.outRate) || 0;
            // 计算税前金额
            const calculateTaxFactor = () => NP.plus(1, NP.divide(taxRate, 100));
            const calculateTaxAdjustedPrice = (basePrice) => this.$common.getDecimalInfo(2, NP.times(basePrice, calculateTaxFactor()));
            const calculateBaseFromTaxed = (taxedValue) => this.$common.getDecimalInfo(3, NP.divide(taxedValue, calculateTaxFactor()));
            info.psmoney = this.$common.getDecimalInfo(3, NP.times(info.psprice, info.orderNum));
            info.money = calculateBaseFromTaxed(info.psmoney);
            info.price = this.$common.getDecimalInfo(2, NP.divide(info.money, info.orderNum));
            // 计算含税成本金额=含税成本价*数量
            info.costMoney = this.$common.getDecimalInfo(3, NP.times(info.woadWcost, info.orderNum));
            // 计算成本金额=成本价*数量
            info.costAmount = this.$common.getDecimalInfo(3, NP.times(info.costPrice, info.orderNum));
            //计算毛利=含税金额-含税成本金额
            info.gross = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.costMoney));
            //计算不含税毛利=金额-成本
            info.taxgross = this.$common.getDecimalInfo(3, NP.minus(info.money, info.costAmount));
            //计算税额=含税金额-金额
            info.taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money));
            // 计算毛利率=毛利/含税金额
            info.grossProfit = this.$common.toFixed2(NP.divide(info.gross, info.psmoney), 2)
            if (info.orPsprice != null && info.orPsprice != undefined) {
                info.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((info.psprice || 0), (info.orPsprice || 0)), 100));
            }
            info.orPsprice = calculateTaxAdjustedPrice(info.orPrice||0);
            info.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), info.orderNum));
            info.orMoney = this.$common.getDecimalInfo(3, NP.times((info.orPrice || 0), info.orderNum));
            info.disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0));
        },
        // 动作集合
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType);
            switch (actionData.actionType) {
                case 0:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: '暂无数据',
                                type: 'error'
                            });
                            return false
                        }
                    }
                    if (this.multipleSelection.length == 0) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.filter(item => item.cmId != this.multipleSelection[0].cmId || item.coId != this.multipleSelection[0].coId).length > 0) {
                        return this.$message({
                            message: '请选择同一客户同一货主下的数据',
                            type: 'error'
                        });
                    }
                    this.getJur()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex]
                this.$refs.printPlan.openDia(info.woamId)
            } else {
                return
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData;
            if (this.activeName == 'first') {
                responseData = await this.$http.orderpoolqueryWdtSuccess(this.getRequestData)
            } else if (this.activeName == 'second') {
                responseData = await this.$http.orderpoolqueryWdtHisOrder(this.getRequestData)
            }
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = this.$common.getIndex(resData.result.list)
                this.returnData.total = resData.result.total
                this.selectedDataIndex = 0
                if (this.activeName == 'second') {
                    this.getDetailsList()
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getDetailsList() {
            let responseData = await this.$http.orderpoolQueryDetail({ ids: [this.returnData.list[this.selectedDataIndex].orderId] })
            if (responseData.status == 200) {
                this.returnData.detailsList = responseData.result
            }
        },
        //获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr
            } catch (ex) {
                return str
            }
        },
        // 获取按钮权限
        async getButtonList() {
            if (this.activeName == "first") {
                this.buttonList = [
                    {
                        actionType: 0,
                        jurName: "生成订单",
                    }
                ]
            } else if (this.activeName == "second") {
                this.buttonList = []
            }
            console.log(this.buttonList);
        },
        initTime() {
            this.getRequestData.start = this.$common.getStartTime()
            this.getRequestData.end = this.$common.getEndTime()
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.initTime()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() - 30 }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>
